if (!customElements.get('chungta-contact')) {
  customElements.define('chungta-contact', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const links = this.querySelector('.ct-contact__links');
      const toggle = this.querySelector('.ct-contact__toggle');
      const dialog = this.querySelector('dialog');
      const wechat = this.querySelector('#wechat-service-btn');
      const hint = this.querySelector('.ct-wechat__hint');
      if (!links || !toggle || !dialog || !wechat) return;
      const setExpanded = expanded => {
        links.hidden = !expanded;
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.title = toggle.getAttribute('aria-label');
        const label = expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
        toggle.setAttribute('aria-label', label);
        toggle.title = label;
      };
      setExpanded(true);
      toggle.hidden = false;
      toggle.addEventListener('click', () => setExpanded(links.hidden), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !dialog.open && !links.hidden) {
          setExpanded(false);
          toggle.focus();
        }
      }, options);
      this.querySelectorAll('[data-conversion]').forEach(link => {
        link.addEventListener('click', () => {
          if (typeof window.gtag === 'function') window.gtag('event', 'conversion', {
            send_to: link.dataset.conversion, transport_type: 'beacon'
          });
        }, options);
      });
      const qrUrl = this.querySelector('.ct-wechat__image').src;
      const getQR = () => this.qrPromise ||= fetch(qrUrl, { signal: this.controller.signal })
        .then(response => { if (!response.ok) throw new Error('QR image unavailable'); return response.blob(); })
        .then(blob => { this.qrBlob = blob; return blob; })
        .catch(() => { this.qrPromise = null; return null; });
      wechat.addEventListener('click', () => {
        hint.hidden = true;
        getQR();
        dialog.showModal();
      }, options);
      this.querySelector('.ct-wechat__close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => { if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      } }, options);
      dialog.addEventListener('close', () => wechat.focus(), options);
      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      this.querySelector('.ct-wechat__save').addEventListener('click', async () => {
        if (isMobile) {
          if (this.qrBlob && navigator.share && navigator.canShare) {
            const file = new File([this.qrBlob], 'wechat_qr.jpg', { type: this.qrBlob.type || 'image/jpeg' });
            if (navigator.canShare({ files: [file] })) {
              try { await navigator.share({ files: [file] }); } catch (error) { if (error.name !== 'AbortError') hint.hidden = false; }
              return;
            }
          }
          hint.hidden = false;
          return;
        }
        const blob = this.qrBlob || await getQR();
        if (!blob) { hint.hidden = false; return; }
        const url = URL.createObjectURL(blob);
        const download = document.createElement('a');
        download.href = url;
        download.download = 'wechat_qr.jpg';
        document.body.append(download);
        download.click();
        download.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); this.qrPromise = null; }
  });
}
